import React from 'react'
import Table from '../../Components/Table'
import '../../Assets/Css/Employees.scss'
import Sidebarlayout from '../../Layouts/Sidebarlayout'

const Employees = () => {
  const header = [
    { field: 'Employee' },
    { field: 'Address' },
    { field: 'Mobile' },
    { field: 'Role' },
    { field: 'Salary' },
    { field: 'Action' }
  ];

  let footer = true;
  const data = [
    {
      Employee: {
        value: 'employee 1',
        value2: 'employee1@email.com',
        src: '',
        type: 'client',
      },
      Address: {
        value: 'PNTC Building',
        value2: 'Satelite',
        city: 'Ahmedabad',
        state: 'Gujarat',
        country: 'India',
        postalcode: 380015,
        type: 'address'
      },
      Action: {
        value: '/employees/edit',
        value2: '/employees/view',
        type: 'action'
      },
      Mobile: {
        value: 9925574123,
        type: 'text'
      },
      Role: {
        value: "full stack developer",
        type: 'text'
      },
      Salary: {
        value: '₹50000',
        type: 'amount'
      }
    },
    {
      Employee: {
        value: 'employee 1',
        value2: 'employee1@email.com',
        src: '',
        type: 'client',
      },
      Address: {
        value: 'PNTC Building',
        value2: 'Satelite',
        city: 'Ahmedabad',
        state: 'Gujarat',
        country: 'India',
        postalcode: 380015,
        type: 'address'
      },
      Action: {
        value: '/employees/edit',
        value2: '/employees/view',
        type: 'action'
      },
      Mobile: {
        value: 9925574123,
        type: 'text'
      },
      Role: {
        value: "full stack developer",
        type: 'text'
      },
      Salary: {
        value: '₹50000',
        type: 'amount'
      }
    },
    {
      Employee: {
        value: 'employee 1',
        value2: 'employee1@email.com',
        src: '',
        type: 'client',
      },
      Address: {
        value: 'PNTC Building',
        value2: 'Satelite',
        city: 'Ahmedabad',
        state: 'Gujarat',
        country: 'India',
        postalcode: 380015,
        type: 'address'
      },
      Action: {
        value: '/employees/edit',
        value2: '/employees/view',
        type: 'action'
      },
      Mobile: {
        value: 9925574123,
        type: 'text'
      },
      Role: {
        value: "full stack developer",
        type: 'text'
      },
      Salary: {
        value: '₹50000',
        type: 'amount'
      }
    },
    {
      Employee: {
        value: 'employee 1',
        value2: 'employee1@email.com',
        src: '',
        type: 'client',
      },
      Address: {
        value: 'PNTC Building',
        value2: 'Satelite',
        city: 'Ahmedabad',
        state: 'Gujarat',
        country: 'India',
        postalcode: 380015,
        type: 'address'
      },
      Action: {
        value: '/employees/edit',
        value2: '/employees/view',
        type: 'action'
      },
      Mobile: {
        value: 9925574123,
        type: 'text'
      },
      Role: {
        value: "full stack developer",
        type: 'text'
      },
      Salary: {
        value: '₹50000',
        type: 'amount'
      }
    },
    {
      Employee: {
        value: 'employee 1',
        value2: 'employee1@email.com',
        src: '',
        type: 'client',
      },
      Address: {
        value: 'PNTC Building',
        value2: 'Satelite',
        city: 'Ahmedabad',
        state: 'Gujarat',
        country: 'India',
        postalcode: 380015,
        type: 'address'
      },
      Action: {
        value: '/employees/edit',
        value2: '/employees/view',
        type: 'action'
      },
      Mobile: {
        value: 9925574123,
        type: 'text'
      },
      Role: {
        value: "full stack developer",
        type: 'text'
      },
      Salary: {
        value: '₹50000',
        type: 'amount'
      }
    }
  ]
  return (
    <Sidebarlayout>
      <div className='employee-main'>
        <div className="page-title">
          <h4>Employees List</h4>
          <div className="edit-btn">
            <button className="custom-btn">Add</button>
          </div>
        </div>
        <div className="employee-list-table">

          <Table header={header} footer={footer} data={data} />
        </div>
      </div>
    </Sidebarlayout>
  )
}

export default Employees
